/**
 * Do not edit directly
 * Generated on Mon, 07 Mar 2022 19:17:29 GMT
 */

module.exports = {
  "BorderRadiusNone": "0px",
  "BorderRadiusSmall": "2px",
  "BorderRadiusMedium": "4px",
  "BorderRadiusLarge": "8px",
  "BorderRadiusExtraLarge": "16px",
  "BorderRadiusJumbo": "24px",
  "BorderRadiusExtraJumbo": "32px",
  "BorderRadiusPill": "500px",
  "BorderRadiusCircle": "50%",
  "BorderWidthNone": "0px",
  "BorderWidthSmall": "1px",
  "BorderWidthMedium": "2px",
  "BorderWidthLarge": "4px",
  "ColorWhite": "#ffffff",
  "ColorBlack": "#000000",
  "ColorInverted": "#ffffff",
  "ColorGray100": "#d5d9e0",
  "ColorGray200": "#b9bfc7",
  "ColorGray300": "#9fa5ad",
  "ColorGray400": "#868d95",
  "ColorGray500": "#697077",
  "ColorGray600": "#50565b",
  "ColorGray700": "#373d42",
  "ColorGray800": "#242a2e",
  "ColorGray900": "#13171a",
  "ColorGray000": "#f6f7f8",
  "ColorGray050": "#e8eaee",
  "ColorBlue100": "#c9d9ff",
  "ColorBlue200": "#97b4ff",
  "ColorBlue300": "#6e95ff",
  "ColorBlue400": "#406ffc",
  "ColorBlue500": "#304ffe",
  "ColorBlue600": "#1d3cc0",
  "ColorBlue700": "#143182",
  "ColorBlue800": "#0d2262",
  "ColorBlue900": "#051243",
  "ColorBlue000": "#edf2ff",
  "ColorOrange100": "#ffd1b3",
  "ColorOrange200": "#ffbc8f",
  "ColorOrange300": "#ffa366",
  "ColorOrange400": "#ff7e29",
  "ColorOrange500": "#fa6400",
  "ColorOrange600": "#cc5200",
  "ColorOrange700": "#993d00",
  "ColorOrange800": "#662900",
  "ColorOrange900": "#331400",
  "ColorOrange000": "#ffede0",
  "ColorPurple100": "#f7d6ff",
  "ColorPurple200": "#efb0ff",
  "ColorPurple300": "#e88eff",
  "ColorPurple400": "#de6efa",
  "ColorPurple500": "#d63ffc",
  "ColorPurple600": "#9624b3",
  "ColorPurple700": "#711587",
  "ColorPurple800": "#4f0059",
  "ColorPurple900": "#260b2b",
  "ColorPurple000": "#fcf1ff",
  "ColorRed100": "#fcd0d3",
  "ColorRed200": "#ffa4a9",
  "ColorRed300": "#ff767c",
  "ColorRed400": "#fb4b53",
  "ColorRed500": "#da1e28",
  "ColorRed600": "#a51920",
  "ColorRed700": "#750e13",
  "ColorRed800": "#570408",
  "ColorRed900": "#2c080a",
  "ColorRed000": "#fff0f1",
  "ColorGreen100": "#9deeb2",
  "ColorGreen200": "#56d679",
  "ColorGreen300": "#3dbb61",
  "ColorGreen400": "#24a148",
  "ColorGreen500": "#198038",
  "ColorGreen600": "#10642a",
  "ColorGreen700": "#054719",
  "ColorGreen800": "#01330f",
  "ColorGreen900": "#081b09",
  "ColorGreen000": "#dafbe4",
  "ColorYellow100": "#ffe1a8",
  "ColorYellow200": "#ffd175",
  "ColorYellow300": "#ffc043",
  "ColorYellow400": "#ffb005",
  "ColorYellow500": "#d59206",
  "ColorYellow600": "#aa7406",
  "ColorYellow700": "#805507",
  "ColorYellow800": "#553707",
  "ColorYellow900": "#2b1908",
  "ColorYellow000": "#fff5e6",
  "ColorCyan100": "#b3e6ff",
  "ColorCyan200": "#6ccaff",
  "ColorCyan300": "#30b0ff",
  "ColorCyan400": "#1191e6",
  "ColorCyan500": "#0072c3",
  "ColorCyan600": "#0058a1",
  "ColorCyan700": "#003d73",
  "ColorCyan800": "#002b50",
  "ColorCyan900": "#07192b",
  "ColorCyan000": "#e3f6ff",
  "ColorPink100": "#ffcfe1",
  "ColorPink200": "#ffa0c2",
  "ColorPink300": "#fa75a6",
  "ColorPink400": "#ee538b",
  "ColorPink500": "#d12765",
  "ColorPink600": "#a11950",
  "ColorPink700": "#760a3a",
  "ColorPink800": "#57002b",
  "ColorPink900": "#2a0a16",
  "ColorPink000": "#fff0f6",
  "ColorViolet100": "#e6d6ff",
  "ColorViolet200": "#d0b0ff",
  "ColorViolet300": "#bb8eff",
  "ColorViolet400": "#9d5efb",
  "ColorViolet500": "#8a3ffc",
  "ColorViolet600": "#6e32c9",
  "ColorViolet700": "#4f2196",
  "ColorViolet800": "#38146b",
  "ColorViolet900": "#1e1033",
  "ColorViolet000": "#f7f1ff",
  "ColorTeal100": "#9ce6df",
  "ColorTeal200": "#5ed1c7",
  "ColorTeal300": "#3eb3a9",
  "ColorTeal400": "#26998f",
  "ColorTeal500": "#008075",
  "ColorTeal600": "#00665d",
  "ColorTeal700": "#004d46",
  "ColorTeal800": "#00332f",
  "ColorTeal900": "#001A17",
  "ColorTeal000": "#e0fffc",
  "ColorAlphaTransparent": "rgba(0, 0, 0, 0.00)",
  "ColorAlphaWhite080": "rgba(255, 255, 255, 0.80)",
  "ColorAlphaGray016": "rgba(19, 23, 26, 0.16)",
  "ColorAlphaGray024": "rgba(19, 23, 26, 0.24)",
  "ColorAlphaGray032": "rgba(19, 23, 26, 0.32)",
  "ColorAlphaGray050": "rgba(19, 23, 26, 0.50)",
  "ColorAlphaGray080": "rgba(19, 23, 26, 0.80)",
  "ColorAlphaBlue024": "rgba(48, 79, 254, 0.24)",
  "ColorAlphaBlue050": "rgba(48, 79, 254, 0.50)",
  "ColorAlphaOrange024": "rgba(250, 100, 0, 0.24)",
  "ColorAlphaOrange050": "rgba(250, 100, 0, 0.50)",
  "ColorAlphaPurple024": "rgba(214, 63, 252, 0.24)",
  "ColorAlphaPurple050": "rgba(214, 63, 252, 0.50)",
  "ColorAlphaRed024": "rgba(218, 30, 40, 0.24)",
  "ColorAlphaRed050": "rgba(218, 30, 40, 0.50)",
  "ColorAlphaGreen024": "rgba(25, 128, 56, 0.24)",
  "ColorAlphaGreen050": "rgba(25, 128, 56, 0.50)",
  "ColorAlphaYellow024": "rgba(213, 146, 6, 0.24)",
  "ColorAlphaYellow050": "rgba(213, 146, 6, 0.50)",
  "ColorAlphaCyan024": "rgba(0, 114, 195, 0.24)",
  "ColorAlphaCyan050": "rgba(0, 114, 195, 0.50)",
  "ColorAlphaPink024": "rgba(209, 39, 101, 0.24)",
  "ColorAlphaPink050": "rgba(209, 39, 101, 0.50)",
  "ColorAlphaViolet024": "rgba(138, 63, 252, 0.24)",
  "ColorAlphaViolet050": "rgba(138, 63, 252, 0.50)",
  "ColorAlphaTeal024": "rgba(0, 128, 117, 0.24)",
  "ColorAlphaTeal050": "rgba(0, 128, 117, 0.50)",
  "ColorBackgroundSuccess": "#9deeb2",
  "ColorBackgroundWarning": "#ffe1a8",
  "ColorBackgroundDanger": "#fcd0d3",
  "ColorBackgroundInfo": "#b3e6ff",
  "ColorBackgroundOverlay": "rgba(19, 23, 26, 0.80)",
  "ColorBackgroundCasual": "#e8eaee",
  "ColorBackgroundBrand": "#edf2ff",
  "ColorBackgroundMajor": "#f6f7f8",
  "ColorBackgroundMinor": "#ffffff",
  "ColorFontMajor": "#242a2e",
  "ColorFontMinor": "#697077",
  "ColorFontInverted": "#ffffff",
  "ColorFontSuccess": "#10642a",
  "ColorFontWarning": "#805507",
  "ColorFontDanger": "#750e13",
  "ColorFontInfo": "#003d73",
  "ColorSocialApplePure": "#000000",
  "ColorSocialAppleClear": "#ffffff",
  "ColorSocialAppleDeep": "#1a1a1a",
  "ColorSocialFacebookPure": "#1877f2",
  "ColorSocialFacebookClear": "#ffffff",
  "ColorSocialFacebookDeep": "#09489b",
  "ColorSocialGooglePure": "#ffffff",
  "ColorSocialGoogleClear": "#757575",
  "ColorSocialGoogleDeep": "#ebebeb",
  "ColorSocialInstagramPure": "#c13584",
  "ColorSocialInstagramClear": "#ffffff",
  "ColorSocialInstagramDeep": "#701f4d",
  "ColorSocialLinkedinPure": "#0a66c1",
  "ColorSocialLinkedinClear": "#ffffff",
  "ColorSocialLinkedinDeep": "#053361",
  "ColorSocialSlackPure": "#4a154b",
  "ColorSocialSlackClear": "#ffffff",
  "ColorSocialSlackDeep": "#230a24",
  "ColorSocialTwitterPure": "#1da1f2",
  "ColorSocialTwitterClear": "#ffffff",
  "ColorSocialTwitterDeep": "#09669f",
  "ColorSocialWhatsappPure": "#25d366",
  "ColorSocialWhatsappClear": "#ffffff",
  "ColorSocialWhatsappDeep": "#167e3d",
  "ColorSocialYoutubePure": "#ff0000",
  "ColorSocialYoutubeClear": "#ffffff",
  "ColorSocialYoutubeDeep": "#990000",
  "ColorSupportSuccessDeep": "#10642a",
  "ColorSupportSuccessPure": "#24a148",
  "ColorSupportSuccessClear": "#9deeb2",
  "ColorSupportWarningDeep": "#805507",
  "ColorSupportWarningPure": "#ffb005",
  "ColorSupportWarningClear": "#ffe1a8",
  "ColorSupportDangerDeep": "#750e13",
  "ColorSupportDangerPure": "#da1e28",
  "ColorSupportDangerClear": "#fcd0d3",
  "ColorSupportInfoDeep": "#003d73",
  "ColorSupportInfoPure": "#1191e6",
  "ColorSupportInfoClear": "#b3e6ff",
  "ColorPrimary": "#304ffe",
  "ColorSecondary": "#fa6400",
  "ColorInteractive100": "#c9d9ff",
  "ColorInteractive200": "#97b4ff",
  "ColorInteractive300": "#6e95ff",
  "ColorInteractive400": "#406ffc",
  "ColorInteractive500": "#304ffe",
  "ColorInteractive600": "#1d3cc0",
  "ColorInteractive700": "#143182",
  "ColorInteractive800": "#0d2262",
  "ColorInteractive900": "#051243",
  "ColorInteractive000": "#edf2ff",
  "ColorInteractiveAlpha": "rgba(48, 79, 254, 0.24)",
  "ColorInteractiveFocus": "rgba(48, 79, 254, 0.50)",
  "ColorInteractiveNormal": "#304ffe",
  "ColorInteractiveHover": "#143182",
  "Elevation00": "0 0 0 1px rgba(19, 23, 26, 0.16)",
  "ElevationUp10": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 -4px 8px -4px rgba(19, 23, 26, 0.24)",
  "ElevationUp20": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 -8px 16px -8px rgba(19, 23, 26, 0.24)",
  "ElevationUp30": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 -16px 32px -16px rgba(19, 23, 26, 0.24)",
  "ElevationDown10": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 4px 8px -4px rgba(19, 23, 26, 0.24)",
  "ElevationDown20": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 8px 16px -8px rgba(19, 23, 26, 0.24)",
  "ElevationDown30": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 16px 32px -16px rgba(19, 23, 26, 0.24)",
  "FontFamilySans": "'Red Hat Text', Arial, sans-serif",
  "FontFamilyPrivate": "'Quero Sans', Arial, Helvetica, sans-serif",
  "FontFamilyMono": "Menlo, Monaco, Consolas, monospace",
  "FontSizeSmall": "0.875rem",
  "FontSizeMedium": "1rem",
  "FontSizeLarge": "1.25rem",
  "FontSizeExtraLarge": "1.5rem",
  "FontSizeJumbo": "1.75rem",
  "FontSizeExtraJumbo": "2rem",
  "FontSizeGiant": "2.25rem",
  "FontSizeExtraGiant": "2.5rem",
  "FontSizeColossal": "3rem",
  "FontSizeExtraColossal": "3.5rem",
  "FontWeightNormal": "400",
  "FontWeightMedium": "500",
  "FontWeightSemiBold": "600",
  "FontWeightBold": "700",
  "FontWeightExtraBold": "800",
  "LineHeightSmall": "1.25rem",
  "LineHeightMedium": "1.5rem",
  "LineHeightLarge": "2rem",
  "LineHeightExtraLarge": "2.25rem",
  "LineHeightJumbo": "2.75rem",
  "LineHeightExtraJumbo": "3rem",
  "LineHeightGiant": "3.5rem",
  "LineHeightExtraGiant": "3.75rem",
  "LineHeightColossal": "4.5rem",
  "LineHeightExtraColossal": "5.25rem",
  "TransitionFunction": "ease-out",
  "TransitionDuration": "300ms",
  "Unit1000": "40px",
  "Unit1100": "44px",
  "Unit1200": "48px",
  "Unit1300": "52px",
  "Unit1400": "56px",
  "Unit1500": "60px",
  "Unit1600": "64px",
  "Unit1700": "68px",
  "Unit1800": "72px",
  "Unit1900": "76px",
  "Unit2000": "80px",
  "Unit2100": "84px",
  "Unit2200": "88px",
  "Unit2300": "92px",
  "Unit2400": "96px",
  "Unit2500": "100px",
  "Unit2600": "104px",
  "Unit2700": "108px",
  "Unit2800": "112px",
  "Unit2900": "116px",
  "Unit3000": "120px",
  "Unit0000": "0px",
  "Unit0025": "1px",
  "Unit0050": "2px",
  "Unit0100": "4px",
  "Unit0200": "8px",
  "Unit0300": "12px",
  "Unit0400": "16px",
  "Unit0500": "20px",
  "Unit0600": "24px",
  "Unit0700": "28px",
  "Unit0800": "32px",
  "Unit0900": "36px",
  "ZIndexSticky": "1000",
  "ZIndexTooltip": "2000",
  "ZIndexDropdown": "3000",
  "ZIndexOverlay": "4000",
  "ZIndexPopover": "5000",
  "ZIndexModal": "6000",
  "ZIndexToast": "7000",
  "ZAvatarBackground": "#edf2ff",
  "ZAvatarBorderColor": "#ffffff",
  "ZAvatarBorderRadius": "50%",
  "ZAvatarBorderWidth": "2px",
  "ZAvatarColor": "#304ffe",
  "ZAvatarFontSize": "1rem",
  "ZAvatarSize": "48px",
  "ZAvatarFontSizeExtraSmall": "0.875rem",
  "ZAvatarSizeExtraSmall": "24px",
  "ZAvatarFontSizeSmall": "0.875rem",
  "ZAvatarSizeSmall": "32px",
  "ZAvatarFontSizeMedium": "1rem",
  "ZAvatarSizeMedium": "48px",
  "ZAvatarFontSizeLarge": "1.25rem",
  "ZAvatarSizeLarge": "64px",
  "ZAvatarFontSizeExtraLarge": "1.5rem",
  "ZAvatarSizeExtraLarge": "80px",
  "ZAvatarBorderColorInteractive": "#304ffe",
  "ZBadgeCounterBackground": "#304ffe",
  "ZBadgeCounterBorderRadius": "500px",
  "ZBadgeCounterColor": "#ffffff",
  "ZBadgeCounterFontWeight": "700",
  "ZBadgeCounterHeight": "16px",
  "ZBadgeCounterWidth": "16px",
  "ZBadgeCounterFontSize": "0.75rem",
  "ZBadgeCounterLineHeight": "1.25rem",
  "ZBadgeCounterBackgroundWatchful": "#da1e28",
  "ZBadgeOrdinationBackground": "#b9bfc7",
  "ZBadgeOrdinationBorderRadius": "50%",
  "ZBadgeOrdinationColor": "#242a2e",
  "ZBadgeOrdinationFontWeight": "700",
  "ZBadgeOrdinationHeight": "24px",
  "ZBadgeOrdinationWidth": "24px",
  "ZBadgeOrdinationFontSize": "1rem",
  "ZBadgeOrdinationLineHeight": "1rem",
  "ZBadgeOrdinationBackgroundIncompleted": "#b9bfc7",
  "ZBadgeOrdinationColorIncompleted": "#242a2e",
  "ZBadgeOrdinationBackgroundCurrentUnselected": "#ffffff",
  "ZBadgeOrdinationBorderColorCurrentUnselected": "#304ffe",
  "ZBadgeOrdinationBorderWidthCurrentUnselected": "2px",
  "ZBadgeOrdinationColorCurrentUnselected": "#304ffe",
  "ZBadgeOrdinationBackgroundCompletedSelected": "#304ffe",
  "ZBadgeOrdinationColorCompletedSelected": "#ffffff",
  "ZBadgeOrdinationBackgroundFinished": "#304ffe",
  "ZBadgeOrdinationColorFinished": "#ffffff",
  "ZBadgeTextBackground": "#868d95",
  "ZBadgeTextBorderRadius": "4px",
  "ZBadgeTextColor": "#ffffff",
  "ZBadgeTextFontWeight": "700",
  "ZBadgeTextLetterSpacing": "0px",
  "ZBadgeTextFontSize": "0.75rem",
  "ZBadgeTextLineHeight": "0.75rem",
  "ZBadgeTextHeight": "16px",
  "ZBadgeTextWidth": "16px",
  "ZButtonShareBorderRadius": "50%",
  "ZButtonShareHeight": "48px",
  "ZButtonShareWidth": "48px",
  "ZButtonSocialFacebookBorderColor": "#09489b",
  "ZButtonSocialFacebookColor": "#ffffff",
  "ZButtonSocialFacebookBackground": "#1877f2",
  "ZButtonSocialFacebookBackgroundHover": "#09489b",
  "ZButtonSocialGoogleBorderColor": "#ebebeb",
  "ZButtonSocialGoogleColor": "#757575",
  "ZButtonSocialGoogleBackground": "#ffffff",
  "ZButtonSocialGoogleBackgroundHover": "#ebebeb",
  "ZButtonSocialAppleBorderColor": "#1a1a1a",
  "ZButtonSocialAppleColor": "#ffffff",
  "ZButtonSocialAppleBackground": "#000000",
  "ZButtonSocialAppleBackgroundHover": "#1a1a1a",
  "ZButtonSocialSlackBorderColor": "#230a24",
  "ZButtonSocialSlackColor": "#ffffff",
  "ZButtonSocialSlackBackground": "#4a154b",
  "ZButtonSocialSlackBackgroundHover": "#230a24",
  "ZButtonSocialLinkedinBorderColor": "#053361",
  "ZButtonSocialLinkedinColor": "#ffffff",
  "ZButtonSocialLinkedinBackground": "#0a66c1",
  "ZButtonSocialLinkedinBackgroundHover": "#053361",
  "ZButtonSocialTwitterBorderColor": "#09669f",
  "ZButtonSocialTwitterColor": "#ffffff",
  "ZButtonSocialTwitterBackground": "#1da1f2",
  "ZButtonSocialTwitterBackgroundHover": "#09669f",
  "ZButtonFontFamily": "'Red Hat Text', Arial, sans-serif",
  "ZButtonFontWeight": "500",
  "ZButtonBorderRadius": "4px",
  "ZButtonBorderWidth": "1px",
  "ZButtonBackgroundPrimary": "#304ffe",
  "ZButtonBorderColorPrimary": "#143182",
  "ZButtonColorPrimary": "#ffffff",
  "ZButtonBorderWidthSecondary": "1px",
  "ZButtonFontSizeSmall": "0.875rem",
  "ZButtonLineHeightSmall": "1.25rem",
  "ZButtonFontSizeMedium": "1rem",
  "ZButtonLineHeightMedium": "1.5rem",
  "ZButtonFontSizeLarge": "1.25rem",
  "ZButtonLineHeightLarge": "2rem",
  "ZCaptionFontFamily": "'Red Hat Text', Arial, sans-serif",
  "ZCaptionFontSize": "0.75rem",
  "ZCaptionFontWeight": "700",
  "ZCaptionLetterSpacing": "0px",
  "ZCaptionLineHeight": "0.75rem",
  "ZCardBackground": "#ffffff",
  "ZCardBorderRadius": "8px",
  "ZCardPadding": "24px",
  "ZCardBoxShadowLow": "0 0 0 1px rgba(19, 23, 26, 0.16)",
  "ZCardBoxShadowHigh": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 4px 8px -4px rgba(19, 23, 26, 0.24)",
  "ZCardBoxShadowHigher": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 8px 16px -8px rgba(19, 23, 26, 0.24)",
  "ZDisplayFontFamily": "'Red Hat Text', Arial, sans-serif",
  "ZDisplayFontWeight": "700",
  "ZDisplayLetterSpacing": "0px",
  "ZDisplayFontSizeMobile": "3rem",
  "ZDisplayLineHeightMobile": "3.75rem",
  "ZDisplayFontSizeDesktop": "3.5rem",
  "ZDisplayLineHeightDesktop": "4.25rem",
  "ZDisplayFontSizeSmallMobile": "2.5rem",
  "ZDisplayLineHeightSmallMobile": "3rem",
  "ZDisplayFontSizeSmallDesktop": "3rem",
  "ZDisplayLineHeightSmallDesktop": "3.75rem",
  "ZDisplayFontSizeMediumMobile": "3rem",
  "ZDisplayLineHeightMediumMobile": "3.75rem",
  "ZDisplayFontSizeMediumDesktop": "3.5rem",
  "ZDisplayLineHeightMediumDesktop": "4.25rem",
  "ZDisplayFontSizeLargeMobile": "3.5rem",
  "ZDisplayLineHeightLargeMobile": "4.25rem",
  "ZDisplayFontSizeLargeDesktop": "4rem",
  "ZDisplayLineHeightLargeDesktop": "5rem",
  "ZDividerBorderColor": "#e8eaee",
  "ZDividerBorderWidth": "2px",
  "ZDividerBorderColorInverted": "#ffffff",
  "ZDividerBorderColorBrand": "#304ffe",
  "ZEmbedImageBorderRadius": "0px",
  "ZEmbedMapBackground": "#f6f7f8",
  "ZEmbedMapHeight": "450px",
  "ZEmbedMapWidth": "100%",
  "ZIconSize": "16px",
  "ZIconArea": "20px",
  "ZIconSizeSmall": "12px",
  "ZIconAreaSmall": "16px",
  "ZIconSizeMedium": "16px",
  "ZIconAreaMedium": "20px",
  "ZIconSizeLarge": "20px",
  "ZIconAreaLarge": "28px",
  "ZIconSizeExtraJumbo": "32px",
  "ZIconAreaExtraJumbo": "40px",
  "ZIconSizeExtraGiant": "40px",
  "ZIconAreaExtraGiant": "52px",
  "ZIconSizeExtraColossal": "48px",
  "ZIconAreaExtraColossal": "60px",
  "ZInputBackground": "#ffffff",
  "ZInputBorderColor": "#b9bfc7",
  "ZInputBorderRadius": "4px",
  "ZInputBorderWidth": "1px",
  "ZInputColor": "#242a2e",
  "ZInputHeight": "46px",
  "ZInputFontSize": "1rem",
  "ZInputLineHeight": "1.5rem",
  "ZInputPlaceholderColor": "#9fa5ad",
  "ZInputBackgroundHover": "#f6f7f8",
  "ZInputBorderColorHover": "#304ffe",
  "ZInputBackgroundDisabled": "#d5d9e0",
  "ZInputBorderColorDisabled": "#b9bfc7",
  "ZInputHeightSmall": "34px",
  "ZInputFontSizeSmall": "0.875rem",
  "ZInputLineHeightSmall": "1.25rem",
  "ZInputHeightLarge": "54px",
  "ZInputFontSizeLarge": "1.25rem",
  "ZInputLineHeightLarge": "2rem",
  "ZLinkFontSize": "1rem",
  "ZLinkLineHeight": "1.5rem",
  "ZLinkFontSizeSmall": "0.875rem",
  "ZLinkLineHeightSmall": "1.25rem",
  "ZLinkFontSizeMedium": "1rem",
  "ZLinkLineHeightMedium": "1.5rem",
  "ZLinkFontSizeLarge": "1.25rem",
  "ZLinkLineHeightLarge": "2rem",
  "ZPopoverBackground": "#ffffff",
  "ZPopoverPadding": "16px",
  "ZPopoverBoxShadow": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 16px 32px -16px rgba(19, 23, 26, 0.24)",
  "ZPopoverFontSize": "1rem",
  "ZPopoverLineHeight": "1.5rem",
  "ZPopoverWidth": "160px",
  "ZPopoverZIndex": "5000",
  "ZPopoverOverlayZIndex": "4000",
  "ZProgressBarBackground": "#e8eaee",
  "ZProgressBarBorderRadius": "4px",
  "ZProgressBarHeight": "8px",
  "ZProgressBarFillBackground": "#304ffe",
  "ZSliderBackground": "#b9bfc7",
  "ZSliderLineBackground": "#304ffe",
  "ZSliderHandleBackground": "#ffffff",
  "ZSliderHandleBorderColor": "#304ffe",
  "ZSliderHandleBorderWidth": "2px",
  "ZTagBackground": "#ffffff",
  "ZTagBorderColor": "#d5d9e0",
  "ZTagBorderRadius": "4px",
  "ZTagBorderWidth": "1px",
  "ZTagColor": "#304ffe",
  "ZTagFontFamily": "'Red Hat Text', Arial, sans-serif",
  "ZTagFontSize": "1rem",
  "ZTagLineHeight": "1.5rem",
  "ZTagFontWeight": "500",
  "ZTagHeight": "32px",
  "ZTagBackgroundHover": "#d5d9e0",
  "ZTagBorderColorHover": "#d5d9e0",
  "ZTagColorHover": "#304ffe",
  "ZTagBackgroundSelected": "#edf2ff",
  "ZTagBorderColorSelected": "#6e95ff",
  "ZTagColorSelected": "#304ffe",
  "ZTagBackgroundDisabled": "#e8eaee",
  "ZTagBorderColorDisabled": "#d5d9e0",
  "ZTagColorDisabled": "#868d95",
  "ZTextFontFamily": "'Red Hat Text', Arial, sans-serif",
  "ZTextFontWeight": "400",
  "ZTextFontSizeMobile": "1rem",
  "ZTextLineHeightMobile": "1.5rem",
  "ZTextFontSizeDesktop": "1rem",
  "ZTextLineHeightDesktop": "1.5rem",
  "ZTextFontSizeSmallMobile": "0.875rem",
  "ZTextLineHeightSmallMobile": "1.25rem",
  "ZTextFontSizeSmallDesktop": "0.875rem",
  "ZTextLineHeightSmallDesktop": "1.25rem",
  "ZTextFontSizeMediumMobile": "1rem",
  "ZTextLineHeightMediumMobile": "1.5rem",
  "ZTextFontSizeMediumDesktop": "1rem",
  "ZTextLineHeightMediumDesktop": "1.5rem",
  "ZTextFontSizeLargeMobile": "1.25rem",
  "ZTextLineHeightLargeMobile": "2rem",
  "ZTextFontSizeLargeDesktop": "1.25rem",
  "ZTextLineHeightLargeDesktop": "2rem",
  "ZTitleFontFamily": "'Red Hat Text', Arial, sans-serif",
  "ZTitleFontWeight": "700",
  "ZTitleLetterSpacing": "0px",
  "ZTitleFontSizeMobile": "1.5rem",
  "ZTitleLineHeightMobile": "2rem",
  "ZTitleFontSizeDesktop": "1.75rem",
  "ZTitleLineHeightDesktop": "2.25rem",
  "ZTitleFontSizeNanoMobile": "1rem",
  "ZTitleLineHeightNanoMobile": "1.25rem",
  "ZTitleFontSizeNanoDesktop": "1rem",
  "ZTitleLineHeightNanoDesktop": "1.25rem",
  "ZTitleFontSizeExtraSmallMobile": "1rem",
  "ZTitleLineHeightExtraSmallMobile": "1.25rem",
  "ZTitleFontSizeExtraSmallDesktop": "1.25rem",
  "ZTitleLineHeightExtraSmallDesktop": "1.5rem",
  "ZTitleFontSizeSmallMobile": "1.25rem",
  "ZTitleLineHeightSmallMobile": "1.5rem",
  "ZTitleFontSizeSmallDesktop": "1.5rem",
  "ZTitleLineHeightSmallDesktop": "2rem",
  "ZTitleFontSizeMediumMobile": "1.5rem",
  "ZTitleLineHeightMediumMobile": "2rem",
  "ZTitleFontSizeMediumDesktop": "1.75rem",
  "ZTitleLineHeightMediumDesktop": "2.25rem",
  "ZTitleFontSizeLargeMobile": "1.75rem",
  "ZTitleLineHeightLargeMobile": "2.25rem",
  "ZTitleFontSizeLargeDesktop": "2rem",
  "ZTitleLineHeightLargeDesktop": "2.5rem",
  "ZTitleFontSizeExtraLargeMobile": "2rem",
  "ZTitleLineHeightExtraLargeMobile": "2.5rem",
  "ZTitleFontSizeExtraLargeDesktop": "2.25rem",
  "ZTitleLineHeightExtraLargeDesktop": "2.75rem",
  "ZToggleSwitchBackground": "#9fa5ad",
  "ZToggleSwitchBorderRadius": "500px",
  "ZToggleSwitchColor": "#ffffff",
  "ZToggleSwitchHeight": "32px",
  "ZToggleSwitchWidth": "72px",
  "ZToggleSwitchFontSize": "0.875rem",
  "ZToggleSwitchLineHeight": "28px",
  "ZTooltipBackground": "#242a2e",
  "ZTooltipColor": "#ffffff",
  "ZTooltipBoxShadow": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 16px 32px -16px rgba(19, 23, 26, 0.24)",
  "ZTooltipFontSize": "0.875rem",
  "ZTooltipLineHeight": "1.25rem",
  "ZAccordionBackground": "rgba(0, 0, 0, 0.00)",
  "ZAccordionBorderWidth": "2px",
  "ZAccordionBorderColor": "#e8eaee",
  "ZAccordionColor": "#242a2e",
  "ZAccordionFontSize": "1rem",
  "ZAccordionLineHeight": "1.5rem",
  "ZAccordionFontWeight": "700",
  "ZAccordionHeight": "2000px",
  "ZAccordionIconColor": "#304ffe",
  "ZAccordionItemMarginBottom": "0",
  "ZAlertBackgroundColor": "#b3e6ff",
  "ZAlertBorderColor": "#1191e6",
  "ZAlertBorderRadius": "4px",
  "ZAlertBorderWidth": "1px",
  "ZAlertColor": "#003d73",
  "ZAlertPadding": "16px",
  "ZAutocompleteBackground": "#ffffff",
  "ZAutocompleteZIndex": "1",
  "ZAutocompleteResultBorderRadius": "4px",
  "ZAutocompleteResultBorderWidth": "1px",
  "ZAutocompleteResultBorderColor": "#e8eaee",
  "ZAutocompleteResultHeight": "300px",
  "ZBottomSheetBackground": "rgba(19, 23, 26, 0.80)",
  "ZBottomSheetZIndex": "6000",
  "ZBreadcrumbItemMaxWidth": "40ch",
  "ZBreadcrumbItemFontSize": "0.875rem",
  "ZBreadcrumbItemLineHeight": "1.25rem",
  "ZBreadcrumbCurrentItemColor": "#242a2e",
  "ZBreadcrumbDivisorColor": "#242a2e",
  "ZBreadcrumbColorInverted": "#ffffff",
  "ZButtonGroupBackground": "transparent",
  "ZButtonGroupBorderColor": "#304ffe",
  "ZButtonGroupBorderRadius": "4px",
  "ZButtonGroupColor": "#304ffe",
  "ZButtonGroupBackgroundHover": "rgba(48, 79, 254, 0.24)",
  "ZButtonGroupFontSizeSmall": "0.875rem",
  "ZButtonGroupLineHeightSmall": "1.25rem",
  "ZButtonGroupFontSizeMedium": "1rem",
  "ZButtonGroupLineHeightMedium": "1.5rem",
  "ZButtonGroupFontSizeLarge": "1.25rem",
  "ZButtonGroupLineHeightLarge": "2rem",
  "ZCarouselColor": "#304ffe",
  "ZCarouselMarginTop": "24px",
  "ZCarouselMaxWidth": "1200px",
  "ZCarouselPaddingBottom": "4px",
  "ZCarouselPaddingLeft": "4px",
  "ZCarouselPaddingRight": "4px",
  "ZCarouselPaddingTop": "2px",
  "ZCarouselPaginationHeight": "32px",
  "ZCarouselPaginationMarginLeft": "16px",
  "ZCarouselPaginationMarginRight": "16px",
  "ZCarouselButtonBackground": "transparent",
  "ZCarouselButtonColor": "#304ffe",
  "ZCarouselButtonHeight": "32px",
  "ZCarouselButtonWidth": "32px",
  "ZCarouselColorDisabled": "#e8eaee",
  "ZCheckboxBackground": "#ffffff",
  "ZCheckboxBorderColor": "#242a2e",
  "ZCheckboxColor": "#242a2e",
  "ZCheckboxBorderWidth": "1px",
  "ZCheckboxBorderRadius": "2px",
  "ZCheckboxHeight": "16px",
  "ZCheckboxWidth": "16px",
  "ZCheckboxMargin": "8px",
  "ZCheckboxBackgroundHover": "#ffffff",
  "ZCheckboxBorderColorHover": "#304ffe",
  "ZCheckboxBackgroundChecked": "#304ffe",
  "ZCheckboxBorderColorChecked": "#304ffe",
  "ZCheckboxColorChecked": "#ffffff",
  "ZCheckboxBorderColorDisabled": "#b9bfc7",
  "ZCheckboxColorInverted": "#ffffff",
  "ZDropdownInputBackground": "#ffffff",
  "ZDropdownInputBorderColor": "#b9bfc7",
  "ZDropdownInputBorderRadius": "4px",
  "ZDropdownInputBorderWidth": "1px",
  "ZDropdownInputColor": "#242a2e",
  "ZDropdownInputFontSize": "1rem",
  "ZDropdownInputLineHeight": "1.5rem",
  "ZDropdownInputBackgroundHover": "#f6f7f8",
  "ZDropdownInputBorderColorHover": "#304ffe",
  "ZDropdownInputIconColor": "#304ffe",
  "ZDropdownInputPlaceholderColor": "#9fa5ad",
  "ZDropdownInputFontSizeLarge": "1.25rem",
  "ZDropdownInputLineHeightLarge": "2rem",
  "ZListBoxBackground": "#ffffff",
  "ZListBoxColor": "#304ffe",
  "ZListBoxBackgroundHover": "#d5d9e0",
  "ZListBoxBackgroundActive": "#304ffe",
  "ZModalZIndex": "6000",
  "ZModalBackground": "#ffffff",
  "ZModalHeight": "100%",
  "ZModalWidth": "750px",
  "ZModalBorderRadius": "0px",
  "ZModalOverlayBackground": "rgba(19, 23, 26, 0.80)",
  "ZPaginationFontSize": "1rem",
  "ZPaginationLineHeight": "1rem",
  "ZPaginationFontWeight": "500",
  "ZPaginationMargin": "4px",
  "ZPaginationHeight": "32px",
  "ZPaginationWidth": "32px",
  "ZPaginationBorderRadius": "4px",
  "ZPaginationBorderWidth": "2px",
  "ZPaginationBackground": "rgba(0, 0, 0, 0.00)",
  "ZPaginationBorderColor": "rgba(0, 0, 0, 0.00)",
  "ZPaginationColor": "#304ffe",
  "ZPaginationBackgroundHover": "rgba(48, 79, 254, 0.24)",
  "ZPaginationBorderColorHover": "rgba(0, 0, 0, 0.00)",
  "ZPaginationColorHover": "#143182",
  "ZPaginationBackgroundSelected": "#edf2ff",
  "ZPaginationBorderColorSelected": "#6e95ff",
  "ZPaginationColorSelected": "#304ffe",
  "ZRadioBackground": "#ffffff",
  "ZRadioBorderColor": "#242a2e",
  "ZRadioColor": "#242a2e",
  "ZRadioBorderWidth": "1px",
  "ZRadioHeight": "16px",
  "ZRadioWidth": "16px",
  "ZRadioMargin": "8px",
  "ZRadioBackgroundHover": "#f6f7f8",
  "ZRadioBorderColorHover": "#304ffe",
  "ZRadioBackgroundSelected": "#304ffe",
  "ZRadioBorderColorSelected": "#304ffe",
  "ZRadioColorSelected": "#242a2e",
  "ZRadioBorderColorDisabled": "#9fa5ad",
  "ZRadioColorInverted": "#ffffff",
  "ZRadioBorderColorInverted": "#ffffff",
  "ZRadioBorderColorInvertedSelected": "#97b4ff",
  "ZRadioInputBorderWidth": "4px",
  "ZStepperBarFontSize": "1rem",
  "ZStepperBarLineHeight": "1.5rem",
  "ZStepperBarBackground": "#b9bfc7",
  "ZStepperBarBorderRadius": "4px",
  "ZStepperBarHeight": "8px",
  "ZStepperBarMargin": "8px",
  "ZStepperBarBackgroundComplete": "#304ffe",
  "ZStepperBarGraphMargin": "8px",
  "ZStepperBarStepMargin": "1px",
  "ZStepperFontSize": "0.875rem",
  "ZStepperLineHeight": "1.25rem",
  "ZStepperDotBorderRadius": "50%",
  "ZStepperDotHeight": "24px",
  "ZStepperDotLinkBackground": "#b9bfc7",
  "ZStepperDotLinkHeight": "4px",
  "ZStepperDotLinkTop": "22px",
  "ZStepperDotLinkLeft": "22px",
  "ZStepperIconColor": "#ffffff",
  "ZStepperDotLinkBackgroundFilled": "#304ffe",
  "ZTabBorderColor": "#e8eaee",
  "ZTabBorderWidth": "4px",
  "ZTabColor": "#868d95",
  "ZTabFontSize": "1rem",
  "ZTabLineHeight": "1.5rem",
  "ZTabFontWeight": "500",
  "ZTabColorActive": "#304ffe",
  "ZTabFontSizeLarge": "1.25rem",
  "ZTabLineHeightLarge": "2rem",
  "ZTextareaBackground": "#ffffff",
  "ZTextareaBorderColor": "#b9bfc7",
  "ZTextareaBorderWidth": "1px",
  "ZTextareaBorderRadius": "4px",
  "ZTextareaColor": "#242a2e",
  "ZTextareaFontSize": "1rem",
  "ZTextareaLineHeight": "1.5rem",
  "ZTextareaHeight": "48px",
  "ZTextareaPlaceholderColor": "#9fa5ad",
  "ZTextareaBackgroundHover": "#f6f7f8",
  "ZTextareaBorderColorHover": "#304ffe",
  "ZTextareaBackgroundDisabled": "#d5d9e0",
  "ZTextareaBorderColorDisabled": "#b9bfc7",
  "ZTextareaHeightSmall": "32px",
  "ZTextareaBorderRadiusSmall": "4px",
  "ZTextareaFontSizeSmall": "0.875rem",
  "ZTextareaLineHeightSmall": "1.25rem",
  "ZTextareaHeightLarge": "48px",
  "ZTextareaBorderRadiusLarge": "4px",
  "ZTextareaFontSizeLarge": "1.25rem",
  "ZTextareaLineHeightLarge": "2rem",
  "ZToastColor": "#ffffff",
  "ZToastBoxShadow": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 16px 32px -16px rgba(19, 23, 26, 0.24)",
  "ZToastBackgroundInfo": "#003d73",
  "ZToastBackgroundSuccess": "#10642a",
  "ZToastBackgroundDanger": "#750e13",
  "ZToastBackgroundWarning": "#805507",
  "ZHeaderBackground": "#ffffff",
  "ZHeaderBoxShadow": "0 0 1px 0 rgba(19, 23, 26, 0.32), 0 4px 8px -4px rgba(19, 23, 26, 0.24)",
  "BreakpointPhone": "480px",
  "BreakpointTablet": "768px",
  "BreakpointDesktop": "992px",
  "BreakpointDesktopLarge": "1200px",
  "BreakpointPhoneMax": "767px",
  "BreakpointTabletMax": "991px",
  "BreakpointDesktopMax": "1199px"
};